import React from 'react';
import Slider from '../components/Slider';
import AboutAccordion from '../components/AboutAccordion';
import QuickLinks from '../components/QuickLinks';
import NewsSection from '../components/NewsSection';

export default function HomePage() {
  return (
    <>
      <Slider />
      <AboutAccordion />
      <QuickLinks />
      <NewsSection />
    </>
  );
}
